import apiClient from "../../client/apiClient"
import { appendQueryParams } from "../../utils"

// Student Report Types
export type StudentAttendanceSummary = {
  totalDays: number;
  presentDays: number;
  absentDays: number;
  lateDays: number;
  excusedDays: number;
  attendancePercentage: number;
  performance: string;
}

export type StudentDailyStatus = {
  status: string;
  remarks?: string;
  markedBy?: string;
  date?: string;
}

export type StudentMonthlyReport = {
  user: any;
  student: any;
  class: any;
  section: any;
  branch: any;
  session: any;
  summary: StudentAttendanceSummary;
  dailyBreakdown: Record<number, string | StudentDailyStatus>;
  month: number;
  year: number;
  monthName: string;
}

export type StudentMonthlyReportResponse = {
  success: boolean;
  message: string;
  data: StudentMonthlyReport[];
  pagination: {
    total: number;
    totalPages: number;
    currentPage: number;
    limit: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
}

export type EmployeeAttendanceSummary = {
  totalDays: number;
  presentDays: number;
  absentDays: number;
  lateDays: number;
  leaveDays: number;
  halfDays: number;
  attendancePercentage: number;
  totalWorkingHours: number;
  averageWorkingHours: number;
  performance: string;
}

export type EmployeeDailyStatus = {
  status: string;
  checkIn?: string;
  checkOut?: string;
  workingHours?: number;
  remarks?: string;
  markedBy?: string;
}

export type EmployeeMonthlyReport = {
  user: any;
  employee: any;
  branch: any;
  session: any;
  summary: EmployeeAttendanceSummary;
  dailyBreakdown: Record<number, string | EmployeeDailyStatus>;
  month: number;
  year: number;
  monthName: string;
}

export type EmployeeMonthlyReportResponse = {
  success: boolean;
  message: string;
  data: EmployeeMonthlyReport[];
  period: {
    month: number;
    year: number;
    monthName: string;
    totalDays: number;
    startDate: string;
    endDate: string;
  };
  pagination: {
    total: number;
    totalPages: number;
    currentPage: number;
    limit: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
}

const ATTENDANCE_ENDPOINT = {
  STUDENT_MONTHLY_REPORT: "/attendance/student-monthly-report",
  EMPLOYEE_MONTHLY_REPORT: "/attendance/employee-monthly-report",
}

const getStudentMonthlyReport = async ({
  month,
  year,
  branchId,
  classId,
  systemId,
  sectionId,
  sessionId,
  searchText: search,
  sortBy = "createdAt",
  sortOrder = "desc",
  page = 1,
  limit = 10,
}: {
  month?: number;
  year?: number;
  branchId?: string;
  classId?: string;
  systemId?: string;
  sectionId?: string;
  sessionId?: string;
  searchText?: string
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  page?: number;
  limit?: number;
} = {}): Promise<StudentMonthlyReportResponse> => {
  const response = await apiClient({
    url: appendQueryParams(ATTENDANCE_ENDPOINT.STUDENT_MONTHLY_REPORT, {
      month,
      year,
      branchId,
      classId,
      sectionId,
      systemId,
      sessionId,
      searchText: search,
      sortBy,
      sortOrder,
      page,
      limit,
    }),
    method: "GET",
  });
  return response.data;
}

const getEmployeeMonthlyReport = async ({
  userId,
  month,
  year,
  branchId,
  department,
  designation,
   searchText: search,
  sortBy = "createdAt",
  sortOrder = "desc",
  page = 1,
  limit = 10,
}: {
  userId?: string;
  month?: number;
  year?: number;
  branchId?: string;
  department?: string;
  designation?: string;
  searchText?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  page?: number;
  limit?: number;
} = {}): Promise<EmployeeMonthlyReportResponse> => {
  const response = await apiClient({
    url: appendQueryParams(ATTENDANCE_ENDPOINT.EMPLOYEE_MONTHLY_REPORT, {
      userId,
      month,
      year,
      branchId,
      department,
      designation,
   searchText: search,
      sortBy,
      sortOrder,
      page,
      limit,
    }),
    method: "GET",
  });
  return response.data;
}

export { 
  getStudentMonthlyReport, 
  getEmployeeMonthlyReport 
};